//
// Main Entry
//
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from 'app/App';
import Modal from 'react-modal';

// Weird - we get warnings in the console if we
// don't explicitly set the Modal appElement.
// https://github.com/reactjs/react-modal/issues/133
Modal.setAppElement('body');

ReactDOM.render(<App />, document.getElementById('app'));
